import { useEffect, useRef } from "react";

const Starfield = ({ density = 130 }) => {
  const canvasRef = useRef(null);
  const mouse = useRef({ x: 0.5, y: 0.5 });

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    let w, h, raf;
    const stars = [];

    const resize = () => {
      w = canvas.width = canvas.offsetWidth * window.devicePixelRatio;
      h = canvas.height = canvas.offsetHeight * window.devicePixelRatio;
    };
    resize();
    window.addEventListener("resize", resize);

    for (let i = 0; i < density; i++) {
      stars.push({
        x: Math.random(),
        y: Math.random(),
        r: Math.random() * 1.6 + 0.3,
        depth: Math.random() * 0.8 + 0.2,
        phase: Math.random() * Math.PI * 2,
        speed: Math.random() * 0.6 + 0.2,
        gold: Math.floor(Math.random() * 3),
      });
    }

    const onMove = (e) => {
      mouse.current = { x: e.clientX / window.innerWidth, y: e.clientY / window.innerHeight };
    };
    window.addEventListener("mousemove", onMove);

    let t = 0;
    const draw = () => {
      t += 0.016;
      ctx.clearRect(0, 0, w, h);
      const px = (mouse.current.x - 0.5) * 2;
      const py = (mouse.current.y - 0.5) * 2;
      for (const s of stars) {
        const tw = 0.45 + 0.55 * Math.abs(Math.sin(t * s.speed + s.phase));
        const x = (s.x + px * 0.05 * s.depth) * w;
        const y = (s.y + py * 0.05 * s.depth + t * 0.002 * s.depth) % 1 * h;
        ctx.beginPath();
        ctx.arc(x, y, s.r * s.depth * window.devicePixelRatio, 0, Math.PI * 2);
        ctx.fillStyle = s.gold === 2
          ? `rgba(236, 182, 220, ${0.6 * tw * s.depth})`
          : s.gold === 1
          ? `rgba(232, 201, 90, ${0.75 * tw * s.depth})`
          : `rgba(253, 251, 247, ${0.5 * tw * s.depth})`;
        ctx.fill();
      }
      raf = requestAnimationFrame(draw);
    };
    draw();

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", resize);
      window.removeEventListener("mousemove", onMove);
    };
  }, [density]);

  return (
    <canvas
      ref={canvasRef}
      data-testid="hero-starfield"
      className="absolute inset-0 h-full w-full"
      aria-hidden="true"
    />
  );
};

export default Starfield;
